import React from 'react';
import Link from 'next/link';
import { ArrowRight, FileText } from 'lucide-react';

export default function DashboardActivity() {
  return (
    <div className="bg-card rounded-2xl border border-border card-shadow overflow-hidden">
      <div className="flex items-center justify-between px-6 py-4 border-b border-border">
        <div>
          <h2 className="text-xl font-700 text-foreground">Recent Activity</h2>
          <p className="text-xs text-muted-foreground mt-0.5">Latest invoice and payment events</p>
        </div>
        <Link href="/invoice-list" className="btn-ghost text-primary text-sm font-600 flex items-center gap-1">
          View all <ArrowRight size={14} />
        </Link>
      </div>
      <div className="flex flex-col items-center justify-center py-16 text-center px-6">
        <div className="w-12 h-12 rounded-2xl bg-secondary flex items-center justify-center mb-4">
          <FileText size={22} className="text-muted-foreground" />
        </div>
        <p className="text-sm font-600 text-foreground">No recent activity</p>
        <p className="text-xs text-muted-foreground mt-1 max-w-xs">
          Invoice payments, new customers, and other events will appear here once you start using NovaInvoice.
        </p>
      </div>
    </div>
  );
}